require('../styles/pos.styl');

import { Domain } from '@shared/app/scripts/services/domain';
import { IsE2e } from '@core/app/scripts/services/is-e2e';
import { SessionManager } from '@shared/app/scripts/services/session-manager';

/**
 * @ngdoc overview
 * @name posApp
 * @description
 * Pos application module
 */
angular.module('posApp', ['v6CoreModule', 'ngSanitize']);

/*
 * Runs app initialising functions.
 */
angular
  .module('posApp')
  .run(
    (
      $log: ng.ILogService,
      $rootScope: ng.IRootScopeService,
      $window: ng.IWindowService,
      cookieStreams,
      domain: Domain,
      intercom,
      isE2e: IsE2e,
      isTest,
      translate: ng.translate.ITranslateService,
    ) => {
      const $translate = translate;

      if (!isTest) {
        // If the sid changes, redirect the user back to www
        cookieStreams.getChange$('sid').subscribe((sid) => {
          $log.info('SID removed or changed! Forwarding user to www');
          $window.location.href = domain.link('www');
        });

        //force https
        if (
          $window.location.href.indexOf('softwearconnect.com') != -1 &&
          window.location.protocol == 'http:'
        ) {
          $window.location = $window.location.href.replace(
            'http://',
            'https://',
          );
        }

        // TODO Store slected text for pos.key. Either:
        // * replace with service
        // * remove all together
        // @ts-ignore
        $rootScope.textProperties = {};

        $window.onresize = () => {
          $rootScope.$broadcast('windowResized');
        };

        // Start Intercom chat bubble
        if (!isE2e) {
          intercom.init();
        }
      }
    },
  );

require('./components');
require('./configs');
require('./controllers');
require('./directives');
require('./filters');
require('./services');
